import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import LoginPage from './routes/LoginPage/index';
import RolePage from './routes/RolePage/index';
import HashCalculationPage from './routes/HashCalculationPage';
import ScenarioPage from './routes/ScenarioPage';
import GameSettingPage from './routes/GameSettingPage'
import NodeHomePage from './routes/NodeHomePage'
import NodeDashboardPage from './routes/NodeDashboardPage'
import DataUploadPage from './routes/DataUploadPage'
import BlockDataPage from './routes/BlockDataPage'
import ChainedBlockDetailPage from './routes/ChainedBlockDetailPage'
import MinerDashboardPage from './routes/MinerDashboardPage'
import AllBlockPage from './routes/AllBlockPage'
import HashBoardWaitingPage from './routes/HashBoardWaitingPage'
import VerificationPage from './routes/VerificationPage'
import PointPage from './routes/PointPage'
import HelpPage from './routes/HelpPage';
import MinerHome from './routes/MinerHomePage';
import CalculateHashPage from './routes/CalculateHashPage';
import DashboradVerfy2 from './routes/DashboardVerfy2';
import Game2HashCalculation from './routes/Game2HashCalculationPage';
import Game2MerkleTreePage from './routes/Game2MerkleTreePage';
import Game2NodeHome from './routes/Game2NodeHome';
import Game2MinerHome from './routes/Game2MinerHome';
import Game2DashBoardDataDetail from './routes/Game2DashBoardDataDetail';
import Game2DashBoardVerfy from './routes/Game2DashBoardVerfy'
import Game2ExerciseScenario from './routes/Game2ExerciseScenario';
import Game2MerkleTreeInfo from './routes/Game2MerkleTreeInfo';
import Game2BlockDetail from './routes/Game2BlockDetails';
import Game2Calculation from './routes/Game2Calculation';
import Game2Help from './routes/Game2Help';
import Game2CalculationDone from './routes/Game2CalculationDone';
import Game2MerkleTree from './routes/Game2MerkleTree';
import Game2UpladPage from './routes/Game2DataUploadPage';

import { BrowserRouter, Routes, Route } from 'react-router-dom'

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes onChange={() => { console.log("test") }}>
        <Route path="/" element={<App />} >
          <Route path="/login" element={<LoginPage />} />
          <Route path="/point" element={<PointPage />} />
          <Route path="/verification" element={<VerificationPage />} />
          <Route path="/hashboardwaiting" element={<HashBoardWaitingPage />} />
          <Route path="/allblock" element={<AllBlockPage />} />
          <Route path="/minerdashboard" element={<MinerDashboardPage />} />
          <Route path="/chainedblockdetail" element={<ChainedBlockDetailPage />} />
          <Route path="/blockdata" element={<BlockDataPage />} />
          <Route path="/dataupload" element={<DataUploadPage />} />
          <Route path="/gamesetting" element={<GameSettingPage />} />
          <Route path="/nodehome" element={<NodeHomePage />} />
          <Route path="/nodedashboard" element={<NodeDashboardPage />} />
          <Route path="/role" element={<RolePage />} />
          <Route path="/scenario" element={<ScenarioPage />} />
          {/* <Route path="/scenario" element={<game2blockdetail />} /> */}
          <Route path="/hashcalculation" element={<HashCalculationPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/minerhome" element={<MinerHome />} />
          <Route path="/calculatehash" element={<CalculateHashPage />} />
          <Route path="/game2dataupload" element={<Game2UpladPage />} />
          <Route path="/game2dashboradverfy2" element={<DashboradVerfy2 />} />
          <Route path="/game2help" element={<Game2Help />} />
          <Route path="/game2calculationdone" element={<Game2CalculationDone />} />
          <Route path="/game2calculation/:did" element={<Game2Calculation />} />
          <Route path="/game2blockdetail/:bid" element={<Game2BlockDetail />} />
          <Route path="/game2merkletreeinfo" element={<Game2MerkleTreeInfo />} />
          <Route path="/game2exercisescenario" element={<Game2ExerciseScenario />} />
          <Route path="/game2dashboardverfy" element={<Game2DashBoardVerfy />} />
          <Route path="/game2dashboarddatadetail" element={<Game2DashBoardDataDetail />} />
          <Route path="/game2minerhome" element={<Game2MinerHome />} />
          <Route path="/game2nodehome" element={<Game2NodeHome />} />
          <Route path="/game2merkletreepage" element={<Game2MerkleTreePage />} />
          <Route path="/game2hashcalculation" element={<Game2HashCalculation />} />
          <Route path="/game2merkletree" element={<Game2MerkleTree />} />

        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
